<template>
  <div class="record-detail">
    <div class="record-detail-wrapper">
      <div class="item">
        <div class="item-label">{{ $t('productName') }}</div>
        <div class="item-content">{{ currentRecord.productName }}</div>
      </div>
      <div class="item">
        <div class="item-label">{{ $t('rate') }}</div>
        <div class="item-content">
          <span>{{ currentRecord.interestPercent }}%</span>
          <span v-if="currentRecord.extraInterestPercent"
                class="extra-number">+ {{ currentRecord.extraInterestPercent }}%</span>
        </div>
      </div>
      <div class="item">
        <div class="item-label">{{ $t('lendingAmount') }}</div>
        <div v-if="currentRecord.orderType === 'FIXED_TRIAL'" class="item-content">
          <span>{{ currentRecord.extraAmount | formatMoney}}</span>
        </div>
        <div v-else class="item-content">
          <span>{{ currentRecord.amount | formatMoney}}</span>
          <span v-if="currentRecord.extraAmount" class="extra-number"> + {{ currentRecord.extraAmount | formatMoney(true, true) }}</span>
          <!--<div class="coupon-name">ICash Bonus</div>-->
        </div>
      </div>
      <div class="item">
        <div class="item-label">{{ type === 'flexible' ? $t('flexibleRevenueLabel') : $t('fixedRevenueLabel') }}</div>
        <div v-if="currentRecord.orderType==='FIXED_TRIAL'" class="item-content">
          {{ currentRecord.extraRevenue | formatMoney }}
        </div>
        <div v-else class="item-content">
          <span>{{ type === 'flexible' ? currentRecord.currentRevenue : currentRecord.revenue | formatMoney}}</span>
          <span v-if="currentRecord.extraRevenue" class="extra-number"> + {{ currentRecord.extraRevenue | formatMoney(true, true)}}</span>
        </div>
      </div>
      <div class="item">
        <div class="item-label">{{ $t('startDate') }}</div>
        <div class="item-content">
          {{ startDate }}
        </div>
      </div>
      <div class="item">
        <div class="item-label">{{ $t('dueDate') }}</div>
        <div class="item-content">
          {{ endDate }}
        </div>
      </div>
      <div class="item">
        <div class="item-label">{{ $t('lendingPeriod') }}</div>
        <div class="item-content">
          {{ type === 'fixed' ? `${currentRecord.period} ${$t(currentRecord.dateUnit)}` : $t('withdrawAnyTime') }}
        </div>
      </div>
      <div class="item" v-if="currentRecord.orderType !== 'FIXED_TRIAL'">
        <div class="item-label">{{$t('operation')}}</div>
        <div class="item-content">
          <md-button type="link" @click="goToBorrowers(currentRecord)">
            {{ $t('viewBorrowers') }}
          </md-button>
        </div>
      </div>
      <div class="item" v-if="currentRecord.orderType !== 'FIXED_TRIAL'">
        <div class="item-label">{{ $t('agreement') }}</div>
        <div class="item-content">
          <md-button type="link" @click="goToAgreement(currentRecord)">
            {{ $t('agreement') }}
          </md-button>
        </div>
      </div>
    </div>
    <div class="sell-tip" v-if="sellButtonVisible">
      <div class="sell-enabled" v-if="sellEnabled" @click="toggleSellPopup(true)">{{ $t('sell') }}</div>
      <div class="sell-enabled" v-else-if="sellProcessing">{{ $t('progressTip') }}</div>
      <div class="sell-disabled" v-else>{{ $t('sellTip') }}</div>
    </div>
    <div class="sell-popup">
      <md-popup v-model="popupVisible">
        <div class="sell-icon">
          <img src="@/assets/image/product/icon_attention.png">
        </div>
        <div class="sell-title">
          {{ $t('popupSellTitle', [removeAmount]) }}
        </div>
        <div class="sell-subtitle">
          {{ $t('popupSellSubTitle') }}
        </div>
        <div class="sell-button">
          <md-button @click="sell" type="primary" round>
            {{ $t('yes') }}
          </md-button>
        </div>
        <div class="sell-button">
          <md-button type="primary" round plain @click="toggleSellPopup(false)">
            {{ $t('no') }}
          </md-button>
        </div>
      </md-popup>
    </div>
  </div>
</template>

<script>
import { Button, Popup } from 'mand-mobile'

export default {
  i18n: {
    messages: {
      en: {
        productName: 'Product Name',
        rate: 'Return Rate',
        lendingAmount: 'Lending Amount',
        flexibleRevenueLabel: 'Total Revenue',
        fixedRevenueLabel: 'Expected return',
        startDate: 'Start Date',
        dueDate: 'Due Date',
        none: 'None',
        withdrawAnyTime: 'Withdraw Anytime',
        lendingPeriod: 'Lending Period',
        operation: 'Operation',
        agreement: 'Lending Service',
        viewBorrowers: 'View Borrowers\' Profile',
        sellTip: 'You can sell after 24H',
        progressTip: 'Repayment is on process, unused balance will update tomorrow',
        sell: 'Sell',
        popupSellTitle: 'Are you sure to remove Rp {0} into your unused balance?',
        popupSellSubTitle: '*Unused balance will update tomorrow',
        yes: 'Yes',
        no: 'No',
        DAY: 'days',
        MONTH: 'month(s)',
      },
      id: {
        productName: 'Nama produk',
        rate: 'Laba pendanaan',
        lendingAmount: 'Jumlah pendanaan',
        flexibleRevenueLabel: 'Total Pendapatan',
        fixedRevenueLabel: 'Pendapatan',
        startDate: 'Tanggal mulai',
        dueDate: 'Jatuh tempo',
        none: 'Tidak ada batas',
        withdrawAnyTime: 'Tarik Kapanpun',
        lendingPeriod: 'Lama periode',
        operation: 'Operasi',
        agreement: 'Perjanjian pendanaan',
        viewBorrowers: 'Lihat Profil peminjam',
        sellTip: 'Anda dapat menarik setelah 24 jam',
        progressTip: 'Penarikan sedang diproses, sisa nominal Anda akan di perbarui besok',
        sell: 'Tarik',
        popupSellTitle: 'Yakin pindahkan Rp {0} ke sisa nominal?',
        popupSellSubTitle: '*Sisa nominal akan diperbarui besok',
        yes: 'Ya',
        no: 'Tidak',
        DAY: 'hari',
        MONTH: 'bulan',
      },
    },
  },
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
  },
  data() {
    return {
      popupVisible: false,
    }
  },
  computed: {
    type() {
      return this.$route.params.type
    },
    currentRecord() {
      return this.$store.state.currentRecord
    },
    removeAmount() {
      return this.$options.filters.formatMoney(this.currentRecord.amount + this.currentRecord.currentRevenue)
    },
    startDate() {
      const record = this.currentRecord
      return this.moment(record.orderStartTimestamp).format('YYYY.MM.DD')
    },
    endDate() {
      const record = this.currentRecord
      return this.type === 'flexible' && record.fundingStatus !== 'REPAID'
        ? this.$t('none') : this.moment(record.orderEndTimestamp).format('YYYY.MM.DD')
    },
    sellButtonVisible() {
      return this.type === 'flexible' && this.currentRecord.fundingStatus !== 'REPAID'
    },
    sellEnabled() {
      return ['RECORDED', 'ACTIVE', 'MATCHED'].includes(this.currentRecord.fundingStatus) &&
        (Number(new Date()) - this.currentRecord.orderStartTimestamp) > 24 * 3600 * 1000 // 购买产品24小时后可以赎回，24小时内为锁定期
    },
    sellProcessing() {
      return this.currentRecord.fundingStatus === 'REPAYING'
    },
  },
  methods: {
    async goToAgreement(item) {
      try {
        if (this.$config.needElectronicContract) {
          const res = await this.$http.get('/digitsign/agreement/downloadBase64', { params: { orderId: item.orderId } })
          const { code } = res.data
          if (code === 'SUCCESS') {
            this.$router.push({
              name: 'AgreementPreview',
              query: { orderId: item.orderId },
            })
            return
          }
        }
        const language = this.$i18n.locale
        const query = `orderId=${item.orderId}&lang=${language}&type=${this.type}&status=${this.currentRecord.fundingStatus}`
        const url = `/static/html/service-platform/service-platform-${language}.html?${query}`
        window.open(url, '_blank')
      } catch (error) {
        console.log(error)
      }
    },
    goToBorrowers(item) {
      this.$router.push(`/user/borrower?orderId=${item.orderId}&orderType=${item.orderType}`)
    },
    toggleSellPopup(flag) {
      this.popupVisible = flag
    },
    async sell() {
      try {
        this.$toast.loading('loading...')
        await this.$http.post(`/order/sell?orderId=${this.currentRecord.orderId}`)
        this.popupVisible = false
        this.$router.push({ name: 'UserRecordList', params: { type: this.$route.params.type } })
      } catch (error) {
        console.log(error)
      } finally {
        this.$toast.hide()
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.record-detail {
}

.record-detail-wrapper {
  background: #fff;
  padding: 10px 16px 0;
}

.item {
  display: flex;
  justify-content: space-between;
  padding: 16px 0;
  border-bottom: 1px solid #eee;
  line-height: 12px;
  .item-label {
    font-size: 12px;
    color: #555;
    line-height: 12px;
  }
  .item-content {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 13px;
    .link {
      font-size: 13px;
      color: #5981FF;
    }
    .extra-number {
      color: color-primary;
      font-weight: bold;
      margin-left: 4px;
    }
    .coupon-name {
      color: color-primary;
      width: 52px;
      height: 16px;
      line-height: 16px;
      font-size: 9px;
      text-align: center;
      background-image: url('../../assets/image/user/ticket/tag-coupon-sm.png');
      background-size: 100% 100%;
    }
  }
}

.sell-tip {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  font-size: 16px;
  text-align: center;
  font-weight: 500;
  color: #fff;
  .sell-disabled {
    padding: 15px 0;
    background: #878B99;
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.24);
  }
  .sell-enabled {
    padding: 15px 10px;
    background: color-primary;
  }
}

.sell-popup /deep/ {
  text-align: center;
  .md-popup-box {
    width: 90%;
    padding: 60px 30px;
    background-color: #fff;
    border-radius: 6px;
  }
  .sell-icon {
    text-align: center;
    margin-bottom: 25px;
    img {
      width: 60px;
      height: 60px;
    }
  }
  .sell-title {
    font-size: 16px;
    font-weight: bold;
    line-height: 1.25em;
    margin-bottom: 8px;
  }
  .sell-subtitle {
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 38px;
  }
  .sell-button .md-button {
    width: 100%;
    margin-bottom: 15px;
  }
}
</style>
